import React from 'react'

/**
 * 检测系统是否启用“减少动画”。
 */
export const prefersReducedMotion = () => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false
  try {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
  } catch {
    return false
  }
}

/**
 * 首页区域减少动画状态 Hook。
 */
export const useReducedMotionPreference = () => {
  const [reducedMotion, setReducedMotion] = React.useState<boolean>(prefersReducedMotion())

  React.useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
    const onChange = () => setReducedMotion(Boolean(mediaQuery.matches))
    onChange()
    try {
      mediaQuery.addEventListener('change', onChange)
      return () => mediaQuery.removeEventListener('change', onChange)
    } catch {
      mediaQuery.addListener(onChange)
      return () => mediaQuery.removeListener(onChange)
    }
  }, [])

  return reducedMotion
}
